// Fetch list

export const FETCH = 'reportVehicleResults.FETCH'
export const FETCH_STARTED = 'reportVehicleResults.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportVehicleResults.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportVehicleResults.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportVehicleResults.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportVehicleResults.CLEAR'

// Export

export const EXPORT = 'reportVehicleResults.EXPORT'
export const EXPORT_FULFILLED = 'reportVehicleResults.EXPORT_FULFILLED'

// Fetch details

export const FETCH_DETAILS = 'reportVehicleResults.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportVehicleResults.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportVehicleResults.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportVehicleResults.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportVehicleResults.FETCH_DETAILS_CANCELLED'

// Clear details

export const CLEAR_DETAILS = 'reportVehicleResults.CLEAR_DETAILS'

// Export details

export const EXPORT_DETAILS = 'reportVehicleResults.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportVehicleResults.EXPORT_DETAILS_FULFILLED'
